module.exports = __webpack_public_path__ + "static/media/cuotas-products.2701f57c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/banner-carousel/new-banner/cuotas-products.png
// module id = 2258
// module chunks = 0